"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    display: 'block',
    borderRadius: palette.gutter / 2 + 'px',
    width: 'auto',
    minWidth: palette.gutter * 20 + 'px',
    height: palette.gutter / 2 + 'px',
    background: palette.elDivider,
    selectedBackground: palette.elAccent,
    pointerBackground: palette.elAccent,
    pointerBorderRadius: '50%',
    pointerWidth: '12px',
    pointerHeight: '12px',
    pointerBoxShadow: 'none',
    focusPointerBackground: palette.elAccentDark,
    focusSelectedBackground: palette.elAccentDark,
    focusPointerBoxShadow: 'none',
    disabledPointerBackground: palette.elDisabled,
    disabledSelectedBackground: palette.elDisabled,
    disabledPointerBoxShadow: 'none'
  };
}